import defaultTheme from "./default";
import krueger from "./krueger";

const themes = { defaultTheme, krueger };

export default themes;
